export default __webpack_public_path__ + "static/media/ROVIcon_dis.24cf0ebe.svg";